
import React, {useEffect, useState} from 'react';


import {
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';

import {getAllmenuitems, customgetmenu_68fb95efe307249250068e11 } from '../../api/menuitems.api'

import './menusection.scss';






const Pmenusection = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {
	const [loftystate_categorymenu8yajw, set_loftystate_categorymenu8yajw] = useState()

	const [loftyendpoint_68abd8cd60a29c1eab0fc416, setLoftyEndpoint_68abd8cd60a29c1eab0fc416] = useState([]);
		const [loftyres_68fb95efe307249250068e11_component_ijkofo, setloftyres_68fb95efe307249250068e11_component_ijkofo] = useState([]);
	const [loftyres_68fb95efe307249250068e11_component_iuixub, setloftyres_68fb95efe307249250068e11_component_iuixub] = useState([]);
	const [loftyres_68fb95efe307249250068e11_component_idxff9, setloftyres_68fb95efe307249250068e11_component_idxff9] = useState([]);
	const [loftyres_68fb95efe307249250068e11_component_i8dsuk, setloftyres_68fb95efe307249250068e11_component_i8dsuk] = useState([]);
	const [loftyres_68fb95efe307249250068e11_component_iav4in, setloftyres_68fb95efe307249250068e11_component_iav4in] = useState([]);
	const [loftyres_68fb95efe307249250068e11_component_ij4kth, setloftyres_68fb95efe307249250068e11_component_ij4kth] = useState([]);
	const [loftyres_68fb95efe307249250068e11_component_ihi23b, setloftyres_68fb95efe307249250068e11_component_ihi23b] = useState([]);
	const [loftyres_68fb95efe307249250068e11_component_ivnp55, setloftyres_68fb95efe307249250068e11_component_ivnp55] = useState([]);


useEffect(() => {
		const loftyHandleData = async () => {
			const loftyres_68abd8cd60a29c1eab0fc416 = await getAllmenuitems({ token: loftytoken || 'asdsa' });
			setLoftyEndpoint_68abd8cd60a29c1eab0fc416(loftyres_68abd8cd60a29c1eab0fc416.data);
		}
		loftyHandleData();
	}, []);

	useEffect(() => {
		const handleLoftyData = async () => {
			try {
				const responseLoftyApps = await customgetmenu_68fb95efe307249250068e11({
					categorymenu: `entradas`,
				});
				setloftyres_68fb95efe307249250068e11_component_ijkofo(responseLoftyApps.data);
			} catch (loftyerror) {
			}
		}
		handleLoftyData();
	}, []);

	useEffect(() => {
		const handleLoftyData = async () => {
			try {
				const responseLoftyApps = await customgetmenu_68fb95efe307249250068e11({
					categorymenu: `paraninos`,
				});
				setloftyres_68fb95efe307249250068e11_component_iuixub(responseLoftyApps.data);
			} catch (loftyerror) {
			}
		}
		handleLoftyData();
	}, []);

	useEffect(() => {
		const handleLoftyData = async () => {
			try {
				const responseLoftyApps = await customgetmenu_68fb95efe307249250068e11({
					categorymenu: `pizzasdeautor`,
				});
				setloftyres_68fb95efe307249250068e11_component_idxff9(responseLoftyApps.data);
			} catch (loftyerror) {
			}
		}
		handleLoftyData();
	}, []);

	useEffect(() => {
		const handleLoftyData = async () => {
			try {
				const responseLoftyApps = await customgetmenu_68fb95efe307249250068e11({
					categorymenu: `newyorkpizza`,
				});
				setloftyres_68fb95efe307249250068e11_component_i8dsuk(responseLoftyApps.data);
			} catch (loftyerror) {
			}
		}
		handleLoftyData();
	}, []);

	useEffect(() => {
		const handleLoftyData = async () => {
			try {
				const responseLoftyApps = await customgetmenu_68fb95efe307249250068e11({
					categorymenu: `pastas`,
				});
				setloftyres_68fb95efe307249250068e11_component_iav4in(responseLoftyApps.data);
			} catch (loftyerror) {
			}
		}
		handleLoftyData();
	}, []);

	useEffect(() => {
		const handleLoftyData = async () => {
			try {
				const responseLoftyApps = await customgetmenu_68fb95efe307249250068e11({
					categorymenu: `sandwiches`,
				});
				setloftyres_68fb95efe307249250068e11_component_ij4kth(responseLoftyApps.data);
			} catch (loftyerror) {
			}
		}
		handleLoftyData();
	}, []);

	useEffect(() => {
		const handleLoftyData = async () => {
			try {
				const responseLoftyApps = await customgetmenu_68fb95efe307249250068e11({
					categorymenu: `ensaladas`,
				});
				setloftyres_68fb95efe307249250068e11_component_ihi23b(responseLoftyApps.data);
			} catch (loftyerror) {
			}
		}
		handleLoftyData();
	}, []);

	useEffect(() => {
		const handleLoftyData = async () => {
			try {
				const responseLoftyApps = await customgetmenu_68fb95efe307249250068e11({
					categorymenu: `extras`,
				});
				setloftyres_68fb95efe307249250068e11_component_ivnp55(responseLoftyApps.data);
			} catch (loftyerror) {
			}
		}
		handleLoftyData();
	}, []);



  
  
  
  

  
  return (
    <div id="id68abd8cd60a29c1eab0fc420" >

      <div id="iwt62" className="">
      
      <div id="icxk" className="">
      
      <div id="iin8q" className="">
      
      <div id="ify1g" className="">
      
      <img
        className=""
        id="ip8xoj"
        src="https://assetsprojects.s3.amazonaws.com/404pziimermwqde.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="iakb66" className="">
      
        <LoftyDropdownComponent
          id="idzgek"
          className="gjs-dropdown-menu-container "
          childrenShow={
            <>
              <div id="ilizri" className="gjs-dropdown-menu-trigger ">
<>
          Menu
        </></div>

            </>
          }
          childrenHover={
            <>
              <div id="ivovlm" className="gjs-dropdown-menu-content " style={{display: 'block'}}>

        <a
          target=""
          className=""
          id="ioe8sf"
          href={`/`}
        >
          
    <div id="icd83c" className="">
    <>Inicio</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="i29bsl"
          href={`/contact`}
        >
          
    <div id="inhqlk" className="">
    <>Menu</>
    </div>
    
    <div id="izfpll" className="">
    <>Contacto</>
    </div>
    
        </a>
        </div>

            </>
          }
        />
        
      </div>
      
      <div id="i95gii" className="">
      
        <a
          target=""
          className=""
          id="ipz0pg"
          href={`/`}
        >
          
    <div id="i2vvpe" className="">
    <>Inicio</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iwg0nn"
          href="#"
        >
          
    <div id="idbyah" className="">
    <>Menú</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iv95sw"
          href={`/contact`}
        >
          
    <div id="icq2ek" className="">
    <>Contacto</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="inak" className="">
      
      <div className="" id="ihc7">
        <>Menú</>
      </div>
      
      </div>
      
      <div id="i062" className="">
      
      <div id="iwoij" className="">
      
      <div className="" id="ip03r">
        <>Nuestro menú ha sido cuidadosamente diseñado para rendir homenaje a los sabores tradicionales de Italia</>
      </div>
      
      <div id="iyljwi" className="">
      
        <div id="ikh07o" className="">
        
          {
            loftyendpoint_68abd8cd60a29c1eab0fc416.map((loftyitem) => (
              <div key={loftyitem._id} className="" id="inyp3t">
                
        <img
          className=""
          id="ii2cwn"
          alt=""
          src={loftyitem.loftyUrl}
        />
        
      <div id="i2meiz" className="">
      
      <div id="i7ppuh" className="">
      
        <div className="" id="i9fbmj">
          
          <div className="" id="">
            {loftyitem.itemlabel}
          </div>
          
        </div>
        
        <div className="" id="iqkl7i">
          
          <div className="" id="">
            {loftyitem.itemprice}
          </div>
          
        </div>
        
      </div>
      
      <div id="ivgkjg" className="">
      
      <button
        type=""
        name=""
        id=""
        className="standard_button "
        
      >
      
      <span className="material-icons " id="ik6dq5">
        
      <span className="material-icons " id="i5xxag">
        <>shopping_cart</>
      </span>
      
      </span>
      
      </button>
      
      </div>
      
      </div>
      
        <div className="" id="itunei">
          
          <div className="" id="">
            {loftyitem.itemdescription}
          </div>
          
        </div>
        
        <div className="" id="iz502k">
          
          <div className="" id="">
            {loftyitem.loftyOriginalName}
          </div>
          
        </div>
        
        <div className="" id="iderx1">
          
          <div className="" id="">
            {loftyitem.loftyFileName}
          </div>
          
        </div>
        
        <div className="" id="ik2kk4">
          
          <div className="" id="">
            {loftyitem.loftyUrl}
          </div>
          
        </div>
        
              </div>
            ))
          }
          
        </div>
        
      </div>
      
      </div>
      
      </div>
      
      <div id="i7ngdd" className="">
      
      <div id="iu8dpx" className="">
      
      <div className="" id="itr6q2">
        <>Nuestro menú ha sido cuidadosamente diseñado para rendir homenaje a los sabores tradicionales de Italia</>
      </div>
      
      <div className="" id="itnbvi">
        
      <span className="fontstyle0 " id="">
        <>E N T R A D A S</>
      </span>
      
      <br className="" id="in25ol" />
      
      </div>
      
      <div id="ij0yhs" className="">
      
        <div id="ijkofo" className="">
        
            {
              loftyres_68fb95efe307249250068e11_component_ijkofo.map((loftyitem_68fb95efe307249250068e11_component_ijkofo) => (
                <div key={loftyitem_68fb95efe307249250068e11_component_ijkofo._id} className="" id="in8wby">
                  
        <img
          className=""
          id="i67k4x"
          alt=""
          src={loftyitem_68fb95efe307249250068e11_component_ijkofo.loftyUrl}
        />
        
      <div id="ilwogj" className="">
      
      <div id="ix73ci" className="">
      
        <div className="" id="iu3uqj">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_ijkofo?.itemlabel}
          </div>
          
        </div>
        
        <div className="" id="ie49zi">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_ijkofo?.itemdescription}
          </div>
          
        </div>
        
      <div id="i5hkyn" className="">
      
      <div className="" id="i0247q">
        <>Lps.</>
      </div>
      
        <div className="" id="is8nwr">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_ijkofo?.itemprice}
          </div>
          
        </div>
        
      </div>
      
      </div>
      
      <div id="igeozo" className="">
      
      <button
        type=""
        name=""
        id=""
        className="standard_button "
        
      >
      
      <span className="material-icons " id="i0ivwi">
        
      <span className="material-icons " id="i886gn">
        <>shopping_cart</>
      </span>
      
      </span>
      
      </button>
      
      </div>
      
      </div>
      
        <div className="" id="i3ehcz">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_ijkofo?.itemdescription}
          </div>
          
        </div>
        
        <div className="" id="i72uk4">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_ijkofo?.loftyOriginalName}
          </div>
          
        </div>
        
        <div className="" id="i2tbpf">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_ijkofo?.loftyFileName}
          </div>
          
        </div>
        
        <div className="" id="ir0rdk">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_ijkofo?.loftyUrl}
          </div>
          
        </div>
        
                </div>
              ))
            }
            
        </div>
        
      </div>
      
      </div>
      
      </div>
      
      <div id="i2gjyz" className="">
      
      <div id="iiydb5" className="">
      
      <div className="" id="i9gsel">
        
      <span className="fontstyle0 " id="">
        <>P A R A  N I Ñ O S</>
      </span>
      
      <br className="" id="iseev4" />
      
      </div>
      
      <div className="" id="ibrakh">
        
      <span className="fontstyle0 " id="">
        <>1 6  P U L G A D A S</>
      </span>
      
      <br className="" id="ib6f5u" />
      
      </div>
      
      <div id="ig4u6k" className="">
      
        <div id="iuixub" className="">
        
            {
              loftyres_68fb95efe307249250068e11_component_iuixub.map((loftyitem_68fb95efe307249250068e11_component_iuixub) => (
                <div key={loftyitem_68fb95efe307249250068e11_component_iuixub._id} className="" id="iqemy6">
                  
        <img
          className=""
          id="iqinbq"
          alt=""
          src={loftyitem_68fb95efe307249250068e11_component_iuixub.loftyUrl}
        />
        
      <div id="ig1nrh" className="">
      
      <div id="ikj19g" className="">
      
        <div className="" id="iovurc">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_iuixub?.itemlabel}
          </div>
          
        </div>
        
        <div className="" id="i5qnev">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_iuixub?.itemdescription}
          </div>
          
        </div>
        
      <div id="i3ylnc" className="">
      
      <div className="" id="iaje5u">
        <>Lps.</>
      </div>
      
        <div className="" id="i961k4">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_iuixub?.itemprice}
          </div>
          
        </div>
        
      </div>
      
      </div>
      
      <div id="ikhjgh" className="">
      
      <button
        type=""
        name=""
        id=""
        className="standard_button "
        
      >
      
      <span className="material-icons " id="i63sfn">
        
      <span className="material-icons " id="iss7ea">
        <>shopping_cart</>
      </span>
      
      </span>
      
      </button>
      
      </div>
      
      </div>
      
        <div className="" id="imheq4">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_iuixub?.itemdescription}
          </div>
          
        </div>
        
        <div className="" id="iwvwzs">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_iuixub?.loftyOriginalName}
          </div>
          
        </div>
        
        <div className="" id="iy8cdk">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_iuixub?.loftyFileName}
          </div>
          
        </div>
        
        <div className="" id="ig23gj">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_iuixub?.loftyUrl}
          </div>
          
        </div>
        
                </div>
              ))
            }
            
        </div>
        
      </div>
      
      </div>
      
      </div>
      
      <div id="i5ir13" className="">
      
      <div id="i8z5oj" className="">
      
      <div className="" id="iruebx">
        
      <span className="fontstyle0 " id="">
        <>P I Z Z A S  D E  A U T O R</>
      </span>
      
      <br className="" id="iu84wd" />
      
      </div>
      
      <div className="" id="it1b7t">
        
      <span className="fontstyle0 " id="">
        <>1 6  P U L G A D A S</>
      </span>
      
      <br className="" id="izw9li" />
      
      </div>
      
      <div id="ihx66u" className="">
      
        <div id="idxff9" className="">
        
            {
              loftyres_68fb95efe307249250068e11_component_idxff9.map((loftyitem_68fb95efe307249250068e11_component_idxff9) => (
                <div key={loftyitem_68fb95efe307249250068e11_component_idxff9._id} className="" id="iplzrl">
                  
        <img
          className=""
          id="idugtz"
          alt=""
          src={loftyitem_68fb95efe307249250068e11_component_idxff9.loftyUrl}
        />
        
      <div id="ilbvyw" className="">
      
      <div id="ipomnp" className="">
      
        <div className="" id="il6yfo">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_idxff9?.itemlabel}
          </div>
          
        </div>
        
        <div className="" id="icl8d3">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_idxff9?.itemdescription}
          </div>
          
        </div>
        
      <div id="iqoxq4" className="">
      
      <div className="" id="ie230v">
        <>Lps.</>
      </div>
      
        <div className="" id="ikw8sw">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_idxff9?.itemprice}
          </div>
          
        </div>
        
      </div>
      
      </div>
      
      <div id="in7zrb" className="">
      
      <button
        type=""
        name=""
        id=""
        className="standard_button "
        
      >
      
      <span className="material-icons " id="ij7ls1">
        
      <span className="material-icons " id="igjuxy">
        <>shopping_cart</>
      </span>
      
      </span>
      
      </button>
      
      </div>
      
      </div>
      
        <div className="" id="iqts9l">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_idxff9?.itemdescription}
          </div>
          
        </div>
        
        <div className="" id="iioq6a">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_idxff9?.loftyOriginalName}
          </div>
          
        </div>
        
        <div className="" id="iikbbr">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_idxff9?.loftyFileName}
          </div>
          
        </div>
        
        <div className="" id="irn0ve">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_idxff9?.loftyUrl}
          </div>
          
        </div>
        
                </div>
              ))
            }
            
        </div>
        
      </div>
      
      </div>
      
      </div>
      
      <div id="i064dd" className="">
      
      <div id="ib2wa7" className="">
      
      <div className="" id="ifnv6d">
        
      <span className="fontstyle0 " id="">
        <>N E W  Y O R K  P I Z Z A</>
      </span>
      
      <br className="" id="iochal" />
      
      </div>
      
      <div className="" id="ip8q3w">
        
      <span className="fontstyle0 " id="">
        <>28  P U L G A D A S</>
      </span>
      
      <br className="" id="ik1w7f" />
      
      </div>
      
      <div id="ihab58" className="">
      
        <div id="i8dsuk" className="">
        
            {
              loftyres_68fb95efe307249250068e11_component_i8dsuk.map((loftyitem_68fb95efe307249250068e11_component_i8dsuk) => (
                <div key={loftyitem_68fb95efe307249250068e11_component_i8dsuk._id} className="" id="ivsqv6">
                  
        <img
          className=""
          id="ix3et7"
          alt=""
          src={loftyitem_68fb95efe307249250068e11_component_i8dsuk.loftyUrl}
        />
        
      <div id="i4zprn" className="">
      
      <div id="i5kn6a" className="">
      
        <div className="" id="iwn55r">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_i8dsuk?.itemlabel}
          </div>
          
        </div>
        
        <div className="" id="if2zei">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_i8dsuk?.itemdescription}
          </div>
          
        </div>
        
      <div id="ietwag" className="">
      
      <div className="" id="icnmyj">
        <>Lps.</>
      </div>
      
        <div className="" id="irwlp9">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_i8dsuk?.itemprice}
          </div>
          
        </div>
        
      </div>
      
      </div>
      
      <div id="iqfv2h" className="">
      
      <button
        type=""
        name=""
        id=""
        className="standard_button "
        
      >
      
      <span className="material-icons " id="i6itwh">
        
      <span className="material-icons " id="iad9vf">
        <>shopping_cart</>
      </span>
      
      </span>
      
      </button>
      
      </div>
      
      </div>
      
        <div className="" id="i614vk">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_i8dsuk?.itemdescription}
          </div>
          
        </div>
        
        <div className="" id="i3g1ii">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_i8dsuk?.loftyOriginalName}
          </div>
          
        </div>
        
        <div className="" id="i5rga4">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_i8dsuk?.loftyFileName}
          </div>
          
        </div>
        
        <div className="" id="iqyrmw">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_i8dsuk?.loftyUrl}
          </div>
          
        </div>
        
                </div>
              ))
            }
            
        </div>
        
      </div>
      
      </div>
      
      </div>
      
      <div id="i4w1bf" className="">
      
      <div id="iyznhg" className="">
      
      <div className="" id="idtdpn">
        
      <span className="fontstyle0 " id="">
        <>P A S T A S</>
      </span>
      
      <br className="" id="iama8t" />
      
      </div>
      
      <div className="" id="iyq0ve">
        
      <span className="fontstyle0 " id="">
        <>I N C L U Y E  P A N  F R E S C O</>
      </span>
      
      <br className="" id="i8n8ml" />
      
      </div>
      
      <div id="iddk6a" className="">
      
        <div id="iav4in" className="">
        
            {
              loftyres_68fb95efe307249250068e11_component_iav4in.map((loftyitem_68fb95efe307249250068e11_component_iav4in) => (
                <div key={loftyitem_68fb95efe307249250068e11_component_iav4in._id} className="" id="i9lhtk">
                  
        <img
          className=""
          id="il41nk"
          alt=""
          src={loftyitem_68fb95efe307249250068e11_component_iav4in.loftyUrl}
        />
        
      <div id="ikkjin" className="">
      
      <div id="i1clnf" className="">
      
        <div className="" id="i81b06">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_iav4in?.itemlabel}
          </div>
          
        </div>
        
        <div className="" id="ipjcte">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_iav4in?.itemdescription}
          </div>
          
        </div>
        
      <div id="iehlvh" className="">
      
      <div className="" id="irpsyf">
        <>Lps.</>
      </div>
      
        <div className="" id="icgeh9">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_iav4in?.itemprice}
          </div>
          
        </div>
        
      </div>
      
      </div>
      
      <div id="ishn47" className="">
      
      <button
        type=""
        name=""
        id=""
        className="standard_button "
        
      >
      
      <span className="material-icons " id="ikzmi6">
        
      <span className="material-icons " id="i0lioj">
        <>shopping_cart</>
      </span>
      
      </span>
      
      </button>
      
      </div>
      
      </div>
      
        <div className="" id="iytm22">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_iav4in?.itemdescription}
          </div>
          
        </div>
        
        <div className="" id="idcxpc">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_iav4in?.loftyOriginalName}
          </div>
          
        </div>
        
        <div className="" id="i3to6s">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_iav4in?.loftyFileName}
          </div>
          
        </div>
        
        <div className="" id="icw86h">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_iav4in?.loftyUrl}
          </div>
          
        </div>
        
                </div>
              ))
            }
            
        </div>
        
      </div>
      
      </div>
      
      </div>
      
      <div id="i6w369" className="">
      
      <div id="iwq639" className="">
      
      <div className="" id="iwx1it">
        
      <span className="fontstyle0 " id="">
        <>S Á N D W I C H E S</>
      </span>
      
      <br className="" id="it83qg" />
      
      </div>
      
      <div className="" id="iwv3zs">
        
      <span className="fontstyle0 " id="">
        <>I N C L U Y E  P A P A S</>
      </span>
      
      <br className="" id="i3wn2q" />
      
      </div>
      
      <div id="i6djzg" className="">
      
        <div id="ij4kth" className="">
        
            {
              loftyres_68fb95efe307249250068e11_component_ij4kth.map((loftyitem_68fb95efe307249250068e11_component_ij4kth) => (
                <div key={loftyitem_68fb95efe307249250068e11_component_ij4kth._id} className="" id="i99qz1">
                  
        <img
          className=""
          id="i61atm"
          alt=""
          src={loftyitem_68fb95efe307249250068e11_component_ij4kth.loftyUrl}
        />
        
      <div id="iykjy6" className="">
      
      <div id="izlbsb" className="">
      
        <div className="" id="i4xv6a">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_ij4kth?.itemlabel}
          </div>
          
        </div>
        
        <div className="" id="i1flpi">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_ij4kth?.itemdescription}
          </div>
          
        </div>
        
      <div id="ihxdmh" className="">
      
      <div className="" id="iyvb9i">
        <>Lps.</>
      </div>
      
        <div className="" id="i6pfzv">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_ij4kth?.itemprice}
          </div>
          
        </div>
        
      </div>
      
      </div>
      
      <div id="iplnvg" className="">
      
      <button
        type=""
        name=""
        id=""
        className="standard_button "
        
      >
      
      <span className="material-icons " id="iah9eq">
        
      <span className="material-icons " id="it2r17">
        <>shopping_cart</>
      </span>
      
      </span>
      
      </button>
      
      </div>
      
      </div>
      
        <div className="" id="i0nq5o">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_ij4kth?.itemdescription}
          </div>
          
        </div>
        
        <div className="" id="ibib8y">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_ij4kth?.loftyOriginalName}
          </div>
          
        </div>
        
        <div className="" id="i36xfz">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_ij4kth?.loftyFileName}
          </div>
          
        </div>
        
        <div className="" id="ircxa3">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_ij4kth?.loftyUrl}
          </div>
          
        </div>
        
                </div>
              ))
            }
            
        </div>
        
      </div>
      
      </div>
      
      </div>
      
      <div id="i2jmzk" className="">
      
      <div id="iz1dy2" className="">
      
      <div className="" id="ia7e0i">
        
      <span className="fontstyle0 " id="">
        <>E N S A L A D A S</>
      </span>
      
      <br className="" id="ikleic" />
      
      </div>
      
      <div className="" id="i09ars">
        
      <span className="fontstyle0 " id="">
        <>I N C L U Y E  F O C A C C I A   Y   B O T E  C O N  A G U A</>
      </span>
      
      <br className="" id="isq2df" />
      
      </div>
      
      <div id="iw8tex" className="">
      
        <div id="ihi23b" className="">
        
            {
              loftyres_68fb95efe307249250068e11_component_ihi23b.map((loftyitem_68fb95efe307249250068e11_component_ihi23b) => (
                <div key={loftyitem_68fb95efe307249250068e11_component_ihi23b._id} className="" id="i5xyhi">
                  
        <img
          className=""
          id="iuruaw"
          alt=""
          src={loftyitem_68fb95efe307249250068e11_component_ihi23b.loftyUrl}
        />
        
      <div id="inhotj" className="">
      
      <div id="iw0rwj" className="">
      
        <div className="" id="iejw6r">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_ihi23b?.itemlabel}
          </div>
          
        </div>
        
        <div className="" id="iobywg">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_ihi23b?.itemdescription}
          </div>
          
        </div>
        
      <div id="itjoid" className="">
      
      <div className="" id="impein">
        <>Lps.</>
      </div>
      
        <div className="" id="ia5rfs">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_ihi23b?.itemprice}
          </div>
          
        </div>
        
      </div>
      
      </div>
      
      <div id="itrflr" className="">
      
      <button
        type=""
        name=""
        id=""
        className="standard_button "
        
      >
      
      <span className="material-icons " id="idx3ft">
        
      <span className="material-icons " id="iqlzk7">
        <>shopping_cart</>
      </span>
      
      </span>
      
      </button>
      
      </div>
      
      </div>
      
        <div className="" id="i3iobt">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_ihi23b?.itemdescription}
          </div>
          
        </div>
        
        <div className="" id="id8vdl">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_ihi23b?.loftyOriginalName}
          </div>
          
        </div>
        
        <div className="" id="i57ntu">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_ihi23b?.loftyFileName}
          </div>
          
        </div>
        
        <div className="" id="isnztm">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_ihi23b?.loftyUrl}
          </div>
          
        </div>
        
                </div>
              ))
            }
            
        </div>
        
      </div>
      
      </div>
      
      </div>
      
      <div id="i79diu" className="">
      
      <div id="ijdavl" className="">
      
      <div className="" id="innccy">
        
      <span className="fontstyle0 " id="">
        <>E X T R A S</>
      </span>
      
      <br className="" id="ikowqj" />
      
      </div>
      
      <div id="i3kkxg" className="">
      
        <div id="ivnp55" className="">
        
            {
              loftyres_68fb95efe307249250068e11_component_ivnp55.map((loftyitem_68fb95efe307249250068e11_component_ivnp55) => (
                <div key={loftyitem_68fb95efe307249250068e11_component_ivnp55._id} className="" id="i9xf2r">
                  
        <img
          className=""
          id="ixdac9"
          alt=""
          src={loftyitem_68fb95efe307249250068e11_component_ivnp55.loftyUrl}
        />
        
      <div id="ilrpj8" className="">
      
      <div id="i5zmqz" className="">
      
        <div className="" id="i3vasu">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_ivnp55?.itemlabel}
          </div>
          
        </div>
        
        <div className="" id="i5ltug">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_ivnp55?.itemdescription}
          </div>
          
        </div>
        
      <div id="iz4b7j" className="">
      
      <div className="" id="ittxlb">
        <>Lps.</>
      </div>
      
        <div className="" id="ij4axg">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_ivnp55?.itemprice}
          </div>
          
        </div>
        
      </div>
      
      </div>
      
      <div id="iiilxk" className="">
      
      <button
        type=""
        name=""
        id=""
        className="standard_button "
        
      >
      
      <span className="material-icons " id="iccyo5">
        
      <span className="material-icons " id="ih86no">
        <>shopping_cart</>
      </span>
      
      </span>
      
      </button>
      
      </div>
      
      </div>
      
        <div className="" id="i40fzf">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_ivnp55?.itemdescription}
          </div>
          
        </div>
        
        <div className="" id="iz39za">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_ivnp55?.loftyOriginalName}
          </div>
          
        </div>
        
        <div className="" id="i8ao42">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_ivnp55?.loftyFileName}
          </div>
          
        </div>
        
        <div className="" id="iw6y8h">
          
          <div className="" id="">
            {loftyitem_68fb95efe307249250068e11_component_ivnp55?.loftyUrl}
          </div>
          
        </div>
        
                </div>
              ))
            }
            
        </div>
        
      </div>
      
      </div>
      
      </div>
      
      <div id="ivp9rg" className="">
      
      <div id="iyb1cd" className="">
      
      <div className="" id="ixbpue">
        <>Horarios de Atencion</>
      </div>
      
      <div id="ihbzju" className="">
      
      <div className="" id="i9s2jl">
        <>Domingo - Jueves</>
      </div>
      
      <div className="" id="i80kgu">
        <>09:00 AM - 10.00 PM</>
      </div>
      
      </div>
      
      <div id="iltjqf" className="">
      
      <div className="" id="i2pomq">
        <>Viernes - Sábado</>
      </div>
      
      <div className="" id="io2w8k">
        <>09:00 AM - 10.00 PM</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ihh0r" className="">
      
      <div id="i0ec4" className="">
      
      <div id="i9haow" className="">
      
      </div>
      
      <div id="ia00al" className="">
      
      </div>
      
      <div id="i8wrb8" className="">
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i2061" className="">
      
      <div id="iq0b9" className="">
      
      </div>
      
      <div id="iizhn" className="">
      
      <div id="izaiq" className="">
      
      <img
        className=""
        id="ifew6t"
        src="https://assetsprojects.s3.amazonaws.com/404pziimern109r.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="i0hei" className="">
      
        <a
          target=""
          className=""
          id="iu98r"
          href="#"
        >
          
    <div id="ixdpz" className="">
    <>Inicio</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iam0d"
          href="#"
        >
          
    <div id="inoxt" className="">
    <>Menu</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iigdg"
          href="#"
        >
          
    <div id="iocf4" className="">
    <>Contacto</>
      <br className="" id="" />
      
    </div>
    
        </a>
        
      </div>
      
      <div id="icv2g" className="">
      
      </div>
      
      <div id="ics7l" className="">
      
        <a
          target=""
          className=""
          id="i7f4f"
          href="#"
        >
          
      <img
        className=""
        id="i5u1b"
        src="https://assetsprojects.s3.amazonaws.com/404pziimb70qgrj.png"
        alt="undefined"
      />
      
        </a>
        
        <a
          target=""
          className=""
          id="ivriv"
          href="#"
        >
          
      <img
        className=""
        id="i0mqz"
        src="https://assetsprojects.s3.amazonaws.com/404pziimb70qw8z.png"
        alt="undefined"
      />
      
        </a>
        
        <a
          target=""
          className=""
          id="icv2s"
          href="#"
        >
          
      <img
        className=""
        id="ixnni"
        src="https://assetsprojects.s3.amazonaws.com/404pziimb70r22p.png"
        alt="undefined"
      />
      
        </a>
        
      </div>
      
      </div>
      
      <div id="ihhz2" className="">
      
      </div>
      
      </div>
      
      <div id="il1wo" className="">
      
      <div className="" id="i6e8e9">
        <>Copyright © 2025.Vita. Todos derechos reservados</>
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pmenusection);
  